export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/spoof-bold-e92aec015794b41f3d29dc693248ae37.woff2";